AuthRoute = require 'mixins/authenticated-route'

App.DeliveryCouriersRoute = Em.Route.extend AuthRoute,

  renderTemplate: (controller, model) ->
    @render 'delivery.couriers.sidebar',
      outlet: 'sidebar',
      controller: controller

    @render 'delivery.couriers.content',
      controller: controller


  model: ->
    organization_id = @get('session').get('currentOrganization.id')
    Em.RSVP.hash restaurants: @store.find('restaurant'), couriers: @store.find('courier')
